import { DEFAULT_COMMIT } from '../constants';

const defaultCommit = {
  type: DEFAULT_COMMIT
};

export default defaultCommit;
